import ImageViewer from './_image-viewer';

export default ImageViewer;
